import React, {useEffect, useRef, useState} from 'react';
import {AuthLayout} from "../../core/layout/AuthLayout";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from '@fullcalendar/interaction';
import itLocale from '@fullcalendar/core/locales/it';
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../core/reducer/pharmacySlice";
import http from "../../shared/utils/http";
import {ContextMenuCalendar} from "./ContextMenuCalendar";
import EventCalendar from "./components/EventCalendar";
import {padNumber} from "../../shared/utils/dateUtils";
import {DatesSetArg, EventMountArg} from "@fullcalendar/core";
import BtnRowActions from "./components/BtnRowActions";
import {useEffectOnlyUpdate} from "../../shared/utils/use_custom/useEffectOnlyUpdate";
import EmployeeItem from "./components/EmployeeItem";
import ReactDOM from "react-dom";
import PrintCalendarData from "./components/PrintCalendarData";
import WarningMsg from "../../shared/ui/warningMsg/WarningMsg";
import ModalSaveModel from "./components/ModalSaveModel";
import {addErrorMessage} from "../../core/errors/errorSlice";
import {useAppDispatch} from "../../app/hooks";
import ModalLoadModel from "./components/ModalLoadModel";
import useActionsCalendar from "./useCustom/useActionsCalendar";
import {HourModel} from "./models/Hour.model";
import useCalendarInitDestroy from "./useCustom/useCalendarInitDestroy";
import useCalendarChange from "./useCustom/useCalendarChange";
import useContextCalendar from "./useCustom/useContextCalendar";
import useHoursCalendar from "./useCustom/useHoursCalendar";
import useFestiveCalendar from "./useCustom/useFestiveCalendar";
import MessageCalendar from "./components/MessageCalendar";
import {selectEmployees} from "../../core/reducer/pharmacySelector";



export function Calendar() {
    const dispatch = useAppDispatch();
    const pharmacy = useSelector(selectSelectedPharmacy)
    const employees = useSelector(selectEmployees);
    const [employeesSaved, setEmployeesSaved] = useState<any[]>([])
    const {calendarRef, setCurrentViewCalendar, currentViewCalendar, isEditable} = useCalendarInitDestroy()
    const {contextMenu, handleContextMenu, resetContext} = useContextCalendar(currentViewCalendar)
    const {hours, setHours, setSavedWeek, savedWeek, events} = useHoursCalendar(employees)
    const [modelsLoaded, setModelsLoaded] = useState();
    const {selectedRange, setSelectedRange, deleteEvent, handleEventDrop, handleEventReceive, changeEventData, handleEventResize} = useCalendarChange(employees, hours, setHours, resetContext)
    const {dayCellClassNames} = useFestiveCalendar(pharmacy)

    const calendarCall = (startDate: Date, endDate: Date) => {
        http.get(`pharmacies/${pharmacy?.idDocument}/hours/${startDate.getFullYear()}/${startDate.getMonth()}/${startDate.getDate()}/${endDate.getFullYear()}/${endDate.getMonth()}/${endDate.getDate()}`).then(res => {
            setHours(res.hours)
            setSavedWeek(res?.savedWeek)
            setEmployeesSaved(res.employeesSaved)
        })
    }


    useEffect(() => {
        http.get(`pharmacies/${pharmacy?.idDocument}/models`).then(res => {
            setModelsLoaded(res.models)
        }, err => {
            dispatch(addErrorMessage({title: 'Errore nel caricamento dei modelli'}))
        })
    }, []);

    const changeDate = (arg: DatesSetArg) => {
        const dateEnd = new Date(arg.end)
        dateEnd.setMinutes(dateEnd.getMinutes() - 1)
        setSelectedRange({
            start: arg.start, // Data di inizio
            end: dateEnd,     // Data di fine
        });

        setCurrentViewCalendar((arg.view.type as any) || "timeGridWeek")

        calendarCall(arg.start, dateEnd)
    }
    useEffectOnlyUpdate(() => {
        pharmacy && selectedRange && calendarCall(selectedRange.start, selectedRange.end)
    }, [pharmacy])
    const calcHours = (idEmployee: string, totHours = 0) => {
        const hoursEmployee = hours.filter(ele => ele.idEmployee === idEmployee)
        const totMinutes = hoursEmployee.reduce((sum, h: any) => sum + (Object.values(h.minutesUpdate || h.minutes).reduce((acc, ele: any) => acc + ele, 0) as number), 0)
        const resultMinutes = (totHours * 60) - totMinutes

        return resultMinutes / 60;
    }
    const employeeList = (employees || []).map(ele => {
        const resultMinutes = calcHours(ele.idDocument, ele.weeklyContractHours)
        return {
            ...ele,
            resultMinutes,
            isSalvageable: resultMinutes <= 0
        }
    })



    const handleEventMount = (info: EventMountArg) => {
        info.el.addEventListener('contextmenu', (event: any) => {
            const calendarApi = calendarRef.current?.getApi();
            const freshEvent = calendarApi?.getEventById(info.event.id) ?? info.event;
            handleContextMenu(event, freshEvent);
        });
        info.el.style.borderLeft = `4px solid ${info.backgroundColor}`;
        info.el.style.backgroundColor = `${info.backgroundColor}88`;
    };







   const {printView, clickHandler, saveModelModal, loadModel, saveModel, pdfRef, loadModelModal, setLoadModelModal, setSaveModelModal} = useActionsCalendar(hours, pharmacy, selectedRange, calendarCall)
    const customButtons = {
        /* next: {
             click: () => {
                 if (!!blockedState.blocked) {
                     console.log("Vai alla prossima pagina");
                     const calendarApi: CalendarApi | undefined = calendarRef.current?.getApi();
                     calendarApi?.next(); // Vai al prossimo
                 } else {
                     console.log("Il pulsante Next è disabilitato");
                 }
             },
         },*/
    }


    const isUpdate = !!hours.find(ele => ele.listUpdate) || employeeList.find(ele => !employeesSaved.includes(ele.idDocument) && hours.filter(el => !!el.list.length).find(el => el.idEmployee === ele.idDocument))
    const isSalvageable = !employeeList.find((ele) => !ele.isSalvageable && (employeesSaved.includes(ele.idDocument) || hours.filter(el => !!el.list.length).find(el => el.idEmployee === ele.idDocument)))
    return (
        <AuthLayout>
            <>
                {pharmacy ? <div className="row gap-2 pt-3">
                    <div className="col-12">
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <div className={'d-flex align-items-center gap-3'}>
                                <h3 className={'text-nowrap'}>Calendario {pharmacy.name}</h3>
                                <MessageCalendar isSalvageable={isSalvageable} isUpdate={isUpdate} savedWeek={savedWeek} />
                            </div>
                            <BtnRowActions isSalvageable={isSalvageable} savedWeek={savedWeek} clickHandler={clickHandler}/>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className={'h-100 '}>
                            <div className={'calendar-component'}>
                                {/* Colonna utenti */}
                                <div id="external-events" className={'calendar-col-user'}>
                                    <h4>Farmacisti</h4>
                                    <div className={'d-flex gap-2 flex-column'}>
                                        {employeeList?.map((employee, k) => (
                                            <EmployeeItem key={k} employee={employee}
                                                          currentViewCalendar={currentViewCalendar}
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div className={'calendar-col-detail p-2'}>
                                    {contextMenu.visible && ReactDOM.createPortal(<ContextMenuCalendar
                                        changeEventData={changeEventData}
                                        deleteEvent={deleteEvent}
                                        contextMenu={contextMenu}
                                        closeContextMenu={resetContext}/>, document.querySelector('.fc-scroller.fc-scroller-liquid-absolute') as any)}

                                    {pharmacy && <FullCalendar
                                        ref={calendarRef}
                                        eventDidMount={handleEventMount}
                                        height={'100%'}
                                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                        initialView="timeGridWeek"

                                        editable={isEditable} // Permette drag and drop
                                        droppable={isEditable} // Permette drag and drop
                                        events={events}
                                        headerToolbar={{
                                            left: 'prev,next today',
                                            center: 'title',
                                            right: 'dayGridMonth,timeGridWeek,timeGridDay'
                                        }}
                                        customButtons={customButtons}
                                        eventDrop={handleEventDrop} // Callback per drag-and-drop
                                        eventResize={handleEventResize} // Callback per resize
                                        eventReceive={handleEventReceive}
                                        slotMinTime="00:00:00" // Ora minima visualizzata
                                        slotMaxTime="23:59:59" // Ora massima visualizzata
                                        slotDuration="00:30:00" // Durata di ciascuno slot
                                        businessHours={pharmacy?.openingHours?.map(ele => ({
                                            daysOfWeek: [1, 2, 3, 4, 5, 6], // Lun-Sab
                                            startTime:
                                                `${padNumber(ele.start.hours)}:${padNumber(ele.start.minutes)}`,
                                            endTime:
                                                `${padNumber(ele.end.hours)}:${padNumber(ele.end.minutes)}`,
                                        }))}
                                        locale={itLocale} // Locale in italiano
                                        firstDay={1} // Inizio della settimana: Lunedì
                                        datesSet={changeDate}

                                        eventContent={(eventInfo) => (
                                            <EventCalendar eventInfo={eventInfo}/>
                                        )}
                                        eventShortHeight={80}
                                        slotEventOverlap={false}
                                        dayCellClassNames={dayCellClassNames}
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                    {printView && !!selectedRange && !!employees && !!hours &&
                        <div ref={pdfRef} style={{'minHeight': '100vh'}} id={'test-print'}>
                            <PrintCalendarData selectedRange={selectedRange} hours={hours}
                                               employees={employees}/>
                        </div>}

                </div> : <div>Selezionare farmacia</div>}
                {saveModelModal &&
                    <ModalSaveModel confirmHandler={saveModel} closeHandler={() => setSaveModelModal(undefined)}/>}
                {loadModelModal &&
                    <ModalLoadModel models={modelsLoaded} confirmHandler={loadModel}
                                    closeHandler={() => setLoadModelModal(undefined)}/>}
            </>
        </AuthLayout>
    );
}


